import { createFileRoute } from '@tanstack/react-router';
import { TripDetailView } from '@/components/TripDetailView';
import { z } from 'zod';

const tripDetailSearchSchema = z.object({
  editTripId: z.string().optional(),
  legId: z.string().optional(),
});

export const Route = createFileRoute('/_auth/operations/trips/$tripId')({
  component: AdminTripDetailRoute,
  validateSearch: tripDetailSearchSchema,
});

function AdminTripDetailRoute() {
  const { tripId } = Route.useParams();
  const { editTripId, legId } = Route.useSearch();

  return <TripDetailView tripId={tripId} editTripId={editTripId} openLegId={legId} />;
}
